import Page from "webPage/Page";
import StickySection from "util/StickySection";

Page.register('single-ebooks', () => {
    new StickySection($('.js-sticky-section'), 960);
});
